import { Component } from 'react'
import { ItemIdentifier } from 'stylewhere/api'
import styled from '@emotion/styled'
import { Box, Icons } from 'stylewhere/components'

interface Props {
  identifier: ItemIdentifier
  last?: boolean
  showStatus?: boolean
  readTid?: string
  retrieveTid?: string
}

interface State {
  dataMatrix: string
}

const bwipjs = require('bwip-js')

export class IdentifierRow extends Component<Props, State> {
  state: State = {
    dataMatrix: ''
  }
  componentDidMount() {
    const { identifier } = this.props
    if (identifier.role === 'data_matrix') this.loadDataMatrix()
  }

  loadDataMatrix = () => {
    const { identifier } = this.props
    const canvas = document.createElement('canvas')
    bwipjs.toCanvas(canvas, {
      bcid: 'datamatrix',
      text: identifier.code
    })
    this.setState({ dataMatrix: canvas.toDataURL('image/png') })
  }

  checkTidColor = (readTid?: string, retrieveTid?: string) => {
    return !readTid || !retrieveTid ? '#353535' : readTid === retrieveTid ? 'darkgreen' : 'red'
  }

  tidIcon = (retrieveTid?: string, readTid?: string) => {
    if (!retrieveTid || !readTid) return null
    if (readTid === retrieveTid) {
      return <Icons.CheckGreen width={20} height={20} />
    }
    return <Icons.Close width={20} height={20} />
  }

  render() {
    const { identifier, last, readTid, retrieveTid } = this.props
    const center = (identifier.type === 'UHF_TAG' && !readTid) || identifier.type !== 'UHF_TAG'
    return (
      <Box vcenter={center} row>
        {identifier.type === 'UHF_TAG' && (
          <Icons.Rfid width={20} height={20} style={{ marginTop: !readTid ? -2 : 12, marginRight: 17 }} />
        )}
        {['NFC_Tag', 'NFC_TAG'].includes(identifier.type) && (
          <Icons.Nfc width={20} height={20} style={{ marginTop: 0, marginRight: 17 }} />
        )}
        {identifier.type !== 'UHF_TAG' && !['NFC_Tag', 'NFC_TAG'].includes(identifier.type) && (
          <Icons.Serial width={20} height={20} style={{ marginTop: -2, marginRight: 17 }} />
        )}
        <IdentifierContainer data-testid={`identifier-container`} data-cy={identifier.code} flex>
          {identifier.role !== 'data_matrix' && <Code vcenter>{identifier.code}</Code>}
          {identifier.role === 'data_matrix' && <DataMatrix alt="" src={this.state.dataMatrix} />}
          {identifier.type === 'UHF_TAG' && !!readTid && (
            <TidContainer vcenter row data-testid={`tid-container`} data-cy={readTid}>
              <Code vcenter style={{ color: this.checkTidColor(readTid, retrieveTid), flex: 1 }}>
                TID: {readTid}
              </Code>
              <IconCheck success={retrieveTid && readTid && retrieveTid === readTid}>
                {this.tidIcon(retrieveTid, readTid)}
              </IconCheck>
            </TidContainer>
          )}
          <Separator last={last} />
        </IdentifierContainer>
      </Box>
    )
  }
}

const DataMatrix = styled.img`
  margin-top: 10px;
  height: 100px;
  width: 100px;
`

const Separator = styled(Box)<{ last?: boolean }>`
  height: 1px;
  background-color: ${({ last }) => (last ? 'transparent' : '#e0e0e0')};
  margin-top: 15px;
`

const IdentifierContainer = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 15px;
`

const TidContainer = styled(Box)`
  margin-top: 10px;
`

const Code = styled(Box)`
  font-style: normal;
  font-weight: bold;
  font-size: 13;
  line-height: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const IconCheck = styled.div<{ success?: boolean }>`
  margin-left: 10px;
  svg * {
    fill: ${({ success }) => (success ? 'green' : 'red')};
  }
`
